// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { gridSize } from '@atlaskit/theme/constants';
export const CODE_FONT_SIZE = 12;
export const CODE_LINE_HEIGHT = '20px';
export const HIGHLIGHT_BORDER_WIDTH = '4px';
export const SPACING = gridSize();
export const LINE_NUMBER_GUTTER = SPACING * 2;
export const VAR_CODE_LINE_NUMBER_BG_COLOR = '--ds--code--line-number-bg-color';
export const VAR_CODE_BG_COLOR = '--ds--code--bg-color';

// selector for codeblock
export const CODE_BLOCK_SELECTOR = `data-ds--code--code-block`;